<template>
  <v-container class="pa-0">
    <MobileTopPart />
    <v-row>
      <v-col>
        <v-container fluid>
          <v-row>
            <v-col
              cols="12"
              class="px-5 pt-5 py-3"
            >
              <SearchForm />
            </v-col>
            <v-col class="white">
              <MyLoader
                v-if="$store.state.progressSearching"
                :style="{
                  marginTop: '150px',
                }"
              />
              <List v-else />
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-row>
      <PageFooter />
    </v-row>
  </v-container>
</template>

<script>
import MyLoader from '@/components/App/_MyLoader'
import List from '@/components/List/List'
import PageFooter from '@/components/App/_PageFooter'
import MobileTopPart from '@/components/Views/Layout/MobileTopPart'
import SearchForm from '@/components/Forms/SearchForm'
export default {
  name: 'HomePageMobile',

  components: {
    SearchForm,
    MobileTopPart,
    PageFooter,
    List,
    MyLoader,
  },
}
</script>
